import { RootState } from '@app/redux/root-reducer';
export const selectAddIntervieweeState = (store: RootState) =>
  store.IntervieweeReducer.addInterviewee;
export const selectUpdateIntervieweeState = (store: RootState) =>
  store.IntervieweeReducer.updateInterviewee;
export const selectIntervieweeState = (store: RootState) => store.IntervieweeReducer.Interviewee;
export const selectPromoteAsInternState = (store: RootState) =>
  store.IntervieweeReducer.promoteAsIntern;
export const selectUpdateInterviweeStatusState = (store: RootState) =>
  store.IntervieweeReducer.updateIntervieweeStatus;
export const selectSearchIntervieweeState = (store: RootState) =>
  store.IntervieweeReducer.searchInterviewee;
export const selectCandidateIntervieweeState = (store: RootState) =>
  store.IntervieweeReducer.candidateSearch;
